import type { SxProps, Theme } from '@mui/material';

export const DASHBOARD_CARD_SX = {
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
  backgroundColor: '#e7edf1',
  border: 0,
  borderRadius: 2,
  boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
  '& .MuiPaper-root': { backgroundColor: 'transparent' },
  '& .MuiToolbar-root': { minHeight: 40, px: 0 },
  '& .MuiTypography-h6': { color: '#4a4a4a', fontSize: '16px !important' },
  '& .MuiTableCell-root': { height: 40, py: 0.75, px: 1, textAlign: 'center' },
  '& .MuiTableBody-root .MuiTableRow-root': { backgroundColor: '#fff' },
} satisfies SxProps<Theme>;

export const DETAIL_CARD_SX = {
  ...DASHBOARD_CARD_SX,
  minHeight: { xs: 320, md: 560 },
} satisfies SxProps<Theme>;

export const LOWER_PANELS_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
  gap: 3,
};

export const LOWER_CARD_SX = {
  ...DASHBOARD_CARD_SX,
  minHeight: 214,
} satisfies SxProps<Theme>;
